import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Movie } from 'src/app/interfaces/cartelera-response';

// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Scrollbar, EffectCoverflow } from 'swiper';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Scrollbar, EffectCoverflow]);

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.css']
})
export class SlideshowComponent implements OnInit, AfterViewInit {

  @Input() movies: Movie[] = [];

  constructor( private router: Router) {
  }

  ngAfterViewInit(): void{
    const swiper = new SwiperCore('.swiper-container-home', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      effect: 'coverflow',
      grabCursor: true,
      centeredSlides: true,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 480px
        480: {
          slidesPerView: 3,
          spaceBetween: 30
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      },
      coverflowEffect: {
        rotate: 70,
        stretch: 100,
        depth: 10,
        modifier: 1,
        slideShadows: true,
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      speed: 500,
      autoplay:{
        delay: 200
      },
    });
  }

  ngOnInit(): void {
    // console.log(this.movies);

  }

  onMovieClick( movie: Movie ): void{
    // console.log(movie);
    this.router.navigate(['/pelicula', movie.id]);
  }


}
